{
  "instances": {
    "loggers": {
      "label": "日志配置",
      "application": "应用",
      "filter": {
        "class_only": "只显示类",
        "configured": "已配置"
      },
      "instance": "实例",
      "new": "新",
      "no_loggers_found": "未找到日志配置。",
      "unset": "重置",
      "setting_loglevel_failed": "设置 {logger} {loglevel} 失败。"
    }
  }
}
